<template>
  <div>
    <el-button
      :loading="downloadLoading"
      style="margin:0 0 20px 20px;"
      type="primary"
      size="medium"
      icon="el-icon-document"
      @click="handleDownload"
    >
      导出收入信息表
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      downloadLoading: false,
      exportList: [],
      columns: [
        {
          title: "是否已取得登记证照",
          value: "is_registration",
        },
        {
          title: "名称（已取得登记证照）",
          value: "y_name",
        },
        {
          title: "统一社会信用代码（纳税人识别号）（已取得登记证照）",
          value: "y_tax_no",
        },
        {
          title: "姓名（未取得登记证照）",
          value: "fullname",
        },
        {
          title: "证件类型（未取得登记证照）",
          value: "id_card_type",
        },
        {
          title: "证件号码（未取得登记证照）",
          value: "id_card",
        },
        {
          title: "国家或地区（未取得登记证照）",
          value: "country",
        },
        {
          title: "收入来源的互联网平台名称",
          value: "internet_platform",
        },
        {
          title: "收入来源的店铺（用户）名称",
          value: "customer_name",
        },
        {
          title: "收入来源的店铺（用户）唯一标识码",
          value: "customer_id",
        },
        {
          title: "销售货物取得的收入总额（已取得登记证照）",
          value: "y_goods_income",
        },
        {
          title: "销售货物取得的收入退款金额（已取得登记证照）",
          value: "y_goods_refund_income",
        },
        {
          title: "销售货物取得的收入净额（已取得登记证照）",
          value: "y_goods_net_income",
        },
        {
          title: "销售无形资产取得的收入总额（已取得登记证照）",
          value: "y_intangible_income",
        },
        {
          title: "销售无形资产取得的收入退款金额（已取得登记证照）",
          value: "y_intangible_refund_income",
        },
        {
          title: "销售无形资产取得的收入净额（已取得登记证照）",
          value: "y_intangible_net_income",
        },
        {
          title: "销售服务取得的收入总额（已取得登记证照）",
          value: "y_service_income",
        },
        {
          title: "销售服务取得的收入退款金额（已取得登记证照）",
          value: "y_service_refund_income",
        },
        {
          title: "销售服务取得的收入净额（已取得登记证照）",
          value: "y_service_net_income",
        },
        {
          title: "收入总额（未取得登记证照）",
          value: "income",
        },
        {
          title: "退款金额（未取得登记证照）",
          value: "refund_income",
        },
        {
          title: "小计（未取得登记证照）",
          value: "subtotal",
        },
        {
          title: "销售货物收入（未取得登记证照）",
          value: "goods_income",
        },
        {
          title: "运输服务收入（未取得登记证照）",
          value: "transport_service_income",
        },
        {
          title: "劳务报酬（未取得登记证照）",
          value: "labor_income",
        },
        {
          title: "稿酬（未取得登记证照）",
          value: "manuscript_income",
        },
        {
          title: "特许权使用费（未取得登记证照）",
          value: "royalties_income",
        },
        {
          title: "从事其他网络交易活动取得的收入（净额）",
          value: "other_income",
        },
        {
          title: "支付给平台的佣金，服务费合计金额",
          value: "commission_income",
        },
        {
          title: "交易数量",
          value: "order_num",
        },
      ],
    };
  },
  created() {
    
    // let b = [];
    // for (let i in a) {
    //   b.push({ title: a[i].description, value: i });
    // }
    // console.log([b]);
  },
  methods: {
    // 初始化文章列表
    async init(type) {
      let params = {...this.search};
      if (type == "export") {
        params.current_page = 1;
        params.page_size = 99999999;
      } else {
        this.downloadLoading = true;
      }
      if(params.month){
        params.month = params?.month.replace(/-/, "")
      }
      let data = await this.$api.getDeclareExport(params);
      if (type == "export") {
        this.downloadLoading = false;
        return data;
      }
    },
    async handleDownload() {
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = this.columns.map((item) => item.title);
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `身份信息${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let tempArr = [];
        this.columns.map((item) => {
          tempArr.push(v[item.value]);
        });
        return tempArr;
      });
    },
  },
};
</script>
<style scoped lang="stylus">
.selectWord
  width: 155px
.date-picker {
  margin-left: 10px;
  width: 250px;
}
.block {
  margin-right: 20px;
}
</style>
